module.exports = __webpack_public_path__ + "img/card-holder.2993bc9c.png";